import { GET_ALL_ASSETS, GET_ASSET_INFO_BY_ID, GET_WELL_KNOWN_ASSETS, SEARCH_ASSETS } from "helpers/constants";
import * as api from "middlewares/apis";
import { liveSearchLoadingStatus, buildingComponent, fetchingDataFromApi } from "actions/loaders";

// Action Creators
export const getAllAssets = (algoChain) => async (dispatch) => {
	try {
		dispatch(buildingComponent(true));
		const { data } = await api.getAllAssets(algoChain);

		dispatch({
			type: GET_ALL_ASSETS,
			payload: data,
		});

		dispatch(buildingComponent(false));
	} catch (error) {
		console.error(error);
	}
};

export const getWellKnownAssets = (algoChain) => async (dispatch) => {
	try {
		dispatch(buildingComponent(true));
		const { data } = await api.getWellKnownAssets(algoChain);

		dispatch({
			type: GET_WELL_KNOWN_ASSETS,
			payload: data?.assets,
		});

		dispatch(buildingComponent(false));
	} catch (error) {
		console.error(error);
	}
};

export const getAssetInfoByID = (params, algoChain) => async (dispatch) => {
	try {
		const { data } = await api.getAssetInfoByID(params, algoChain);

		if (data?.data?.asset)
			dispatch({
				type: GET_ASSET_INFO_BY_ID,
				payload: data.data.asset,
			});
	} catch (error) {
		console.error(error);
	}
};

export const getAssetPricesByAlammex = async () => {
	try {
		const { data } = await api.getAssetPricesByAlammex();

		if (data) return data;
		else return null;
	} catch (error) {
		console.error(error);
	}
};

export const searchAssets = (searchQueryString, algoChain) => async (dispatch) => {
	try {
		dispatch(liveSearchLoadingStatus(true));
		const { data } = await api.searchAssets(searchQueryString, algoChain);

		dispatch({
			type: SEARCH_ASSETS,
			payload: data,
		});

		dispatch(liveSearchLoadingStatus(false));
	} catch (error) {
		console.error(error);
	}
};
